module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Verzasca_TI_COA-5cae3d306fe3cc4d07f19e4418d8b95c.svg";